// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 180 ? "App" : chunkId) + "." + {"180":"6fdaabcc","453":"7b368ace"}[chunkId] + ".chunk.js";
};